import type { CustomerGroup } from '~/types/GraphQL';

export default {
  isKikEmployee: (key: CustomerGroup['key']) => key === 'MAKIK' || false,
  isBigBuyer: (key: CustomerGroup['key']) => key === 'GRKUNDEN' || false,
  getDiscountLabel(key: CustomerGroup['key']) {
    if (this.isKikEmployee(key)) {
      return 'KiK employee discount';
    }

    return 'Discount savings';
  },
};
